import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  role: "table",
  class: "p-datatable-table"
}
const _hoisted_2 = {
  class: "p-datatable-tbody",
  role: "rowgroup"
}
const _hoisted_3 = {
  class: "item",
  role: "cell"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "p-column-title" }, "Item", -1)
const _hoisted_5 = {
  class: "row",
  style: {"display":"flex","justify-content":"space-between"}
}
const _hoisted_6 = {
  class: "title",
  style: {"flex-grow":"1"}
}
const _hoisted_7 = { class: "title" }
const _hoisted_8 = {
  key: 0,
  class: "notes",
  style: {"margin-left":"2rem"}
}
const _hoisted_9 = { style: {"margin-bottom":"0"} }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("strong", null, "Comment:", -1)
const _hoisted_11 = {
  key: 1,
  class: "notes",
  style: {"margin-left":"2rem"}
}
const _hoisted_12 = { style: {"margin-bottom":"0"} }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("strong", null, "Notes:", -1)
const _hoisted_14 = {
  key: 2,
  class: "notes",
  style: {"margin-left":"2rem"}
}
const _hoisted_15 = { style: {"margin-bottom":"0"} }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("strong", null, "Measurements: ", -1)
const _hoisted_17 = {
  key: 3,
  class: "documents",
  style: {"margin-left":"2rem"}
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { style: {"margin-bottom":"0"} }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Upload(s):")
], -1)
const _hoisted_19 = {
  key: 1,
  class: "video-container"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-play" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("img", {
  class: "modal-content",
  id: "previewNoVideo",
  src: "/default_no_video.png",
  alt: "Image",
  style: {"display":"none"}
}, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("video", {
  class: "modal-content",
  id: "previewVideo",
  style: {"display":"none"},
  controls: "",
  autoplay: ""
}, [
  /*#__PURE__*/_createElementVNode("source")
], -1)




export default /*#__PURE__*/_defineComponent({
  name: 'ResultTable',
  props: ['items'],
  setup(__props) {

const props = __props



const getThumbnail = (media: string) => {
    return media.split('|')[0];
}

const getVideo = (media: string) => {
    return media.split('|')[1];
}

const openVideoPopup = async (event, media) => {

    if (event.target.src.endsWith('/default_no_video.png') === true) {
        return;
    }
    
    const modalImage = document.getElementById("previewNoVideo");
    modalImage.style.display = 'none';

    const previewModal = document.getElementById("PreviewModal");
    previewModal.style.display = 'block';

    const modalVideo = document.getElementById("previewVideo");
    modalVideo.style.display = 'block';

    const baseUrl = getVideo(media); // https://api-files.sproutvideo.com/file/0690d2b11d1aefcf8f/7d38b83fb71f18a6/
    const resolutions = ["720", "480", "360", "240"];
    const videoAssets = resolutions.map(resolution => `${baseUrl}${resolution}.mp4`);
    let isValid = false;
    for (let index=0; index < videoAssets.length; index++) {
        const response = await fetch(videoAssets[index]);
        if (response.status >= 200 && response.status < 400) {
            modalVideo.src = videoAssets[index];
            isValid = true;
            break; // this is to stop the iteration
        }
    }
    
    if (isValid === false) {
        modalVideo.style.display = 'none';
        modalImage.style.display = 'block';
    }
}

const handleImageError = (inspectionIndex, mediaKeyIndex, srcImg) => {
    const errorImage: HTMLImageElement | null = document.querySelector(`img[inspection-index="${inspectionIndex}"][media-index="${mediaKeyIndex}"]`);
    if (errorImage) {
        errorImage.src = srcImg;
    }
}

const closeVideoPopup = () => {
    let previewModal = document.getElementById("PreviewModal");
    previewModal.style.display = 'none';
    let modalVideo = document.getElementById("previewVideo");
    modalVideo.src = null;
}

return (_ctx: any,_cache: any) => {
  const _component_Image = _resolveComponent("Image")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("table", _hoisted_1, [
      _createElementVNode("tbody", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.items, (InspectionLine, inspectionIndex) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: inspectionIndex,
            class: "",
            role: "row",
            draggable: "false"
          }, [
            _createElementVNode("td", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("h4", _hoisted_7, _toDisplayString(InspectionLine.Title), 1),
                  (InspectionLine.Comment)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("p", _hoisted_9, [
                          _hoisted_10,
                          _createTextVNode(" " + _toDisplayString(InspectionLine.Comment), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (InspectionLine.Notes)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("p", _hoisted_12, [
                          _hoisted_13,
                          _createTextVNode(" " + _toDisplayString(InspectionLine.Notes), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (InspectionLine.Unit !== '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("p", _hoisted_15, [
                          _hoisted_16,
                          _createTextVNode(" LF: " + _toDisplayString(InspectionLine.LF + InspectionLine.UnitText) + " RF: " + _toDisplayString(InspectionLine.RF + InspectionLine.UnitText) + " LR: " + _toDisplayString(InspectionLine.LR + InspectionLine.UnitText) + " RR: " + _toDisplayString(InspectionLine.RR + InspectionLine.UnitText), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (InspectionLine.MediaKeys.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _hoisted_18,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(InspectionLine.MediaKeys, (media, mediaKeyIndex) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "p-image p-image-preview-container item-image",
                            key: mediaKeyIndex,
                            style: {"margin-right":"1.5rem"}
                          }, [
                            (media.includes('|') === false)
                              ? (_openBlock(), _createBlock(_component_Image, {
                                  key: 0,
                                  "inspection-index": inspectionIndex,
                                  "media-index": mediaKeyIndex,
                                  class: "p-overlay-badge",
                                  alt: "Image",
                                  width: "150",
                                  preview: "",
                                  src: media
                                }, null, 8, ["inspection-index", "media-index", "src"]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                  _hoisted_20,
                                  _createVNode(_component_Image, {
                                    "inspection-index": inspectionIndex,
                                    "media-index": mediaKeyIndex,
                                    alt: "Image",
                                    width: "150",
                                    src: getThumbnail(media),
                                    onClick: event => openVideoPopup(event, media),
                                    onError: ($event: any) => (handleImageError(inspectionIndex, mediaKeyIndex, '/default_no_video.png'))
                                  }, null, 8, ["inspection-index", "media-index", "src", "onClick", "onError"])
                                ]))
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", {
      class: "preview-modal",
      id: "PreviewModal"
    }, [
      _createElementVNode("span", {
        class: "close",
        id: "closeButton",
        onClick: closeVideoPopup
      }, "×"),
      _hoisted_21,
      _hoisted_22
    ])
  ]))
}
}

})